import type { PolicyDetails } from './types';

export const getConsentPolicy = (): PolicyDetails => {
  if (!window.consentPolicyManager) {
    console.log(
      "[site-bi] Couldn't get current consent policy because consentPolicyManager is not defined",
    );

    return {
      defaultPolicy: true,
      policy: {
        functional: true,
        analytics: true,
        essential: true,
        advertising: true,
        dataToThirdParty: true,
      },
    };
  }

  return window.consentPolicyManager.getCurrentConsentPolicy();
};
